module.exports = __webpack_public_path__ + "6a6b98e4d153c8d6c482169294589bf5.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/Lankenau2.jpg
// module id = 479
// module chunks = 0